import request from "@/util/http";
/**
 * 忘记密码
 */
export function forgot(params) {
	return request({
		url: '/upms/shop/password/forgot',
		method: 'get',
		params: params,
	})
}

/**
 * 会员忘记密码
 */
export function forgot_member(params) {
	return request({
		url: '/upms/shop/password/forgot_member',
		method: 'post',
		params: params,
	})
}

/**
 * 商家忘记密码
 */
export function forgot_merchant(params) {
	return request({
		url: '/upms/shop/password/forgot_merchant',
		method: 'post',
		params: params,
	})
}

/**
 * 会员重置密码
 */
export function reset_member_load(params) {
	return request({
		url: '/upms/shop/password/reset_member_load',
		method: 'get',
		params: params,
	})
}


/**
 * 商家重置密码
 */
export function reset_merchant_load(params) {
	return request({
		url: '/upms/shop/password/reset_merchant_load',
		method: 'get',
		params: params,
	})
}

/**
 * 会员重置密码
 */
export function reset_member(params) {
	return request({
		url: '/upms/shop/password/reset_member',
		method: 'post',
		params: params,
	})
}



/**
 * 商家重置密码
 */
export function reset_merchant(params) {
	return request({
		url: '/upms/shop/password/reset_merchant',
		method: 'post',
		params: params,
	})
}

export function update(params) {
	return request({
		url: '/upms/shop/password/update',
		method: 'put',
		params: params,
	})
}

export function edit(params) {
	return request({
		url: '/upms/shop/password/edit',
		method: 'get',
		params: params,
	})
}

/**
 * 验证当前密码
 */
export function check_current_password(params) {
	return request({
		url: '/upms/shop/password/check_current_password',
		method: 'get',
		params: params,
	})
}


// module.exports = {
// 	forgot,
// 	forgot_member,
// 	forgot_merchant,
// 	reset_member_load,
// 	reset_merchant_load,
// 	reset_member,
// 	reset_merchant,
// 	check_current_password,
// 	edit,
// 	update
// }
